<template>
  <NButton btn="solid">
    Solid Button
  </NButton>
</template>
